import { emptySplitApi } from "./index";

export const userCouponApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        validateCoupon: builder.mutation({
            query: ({couponCode, reportInvalid}) => ({
                url: `api/v1/auth-service/user-coupon/validation/${couponCode}?reportInvalid=${reportInvalid}`,
                method: "POST"
            })
        }),
    }),
    overrideExisting: false,
});

export const {
    useValidateCouponMutation,
} = userCouponApi;
